<template>
  <BlogPostSimpleGuideonhowtobuildaRAGsystemMainArea/>
</template>

<script>
import BlogPostSimpleGuideonhowtobuildaRAGsystemMainArea from '@/components/blog/blog-post-the-simple-guide-on-how-to-build-a-rag-system/index.vue';

export default {
  name:'BlogPostSimpleGuideonhowtobuildaRAGsystem',
  components:{BlogPostSimpleGuideonhowtobuildaRAGsystemMainArea}
}
</script>
